module.exports = __webpack_public_path__ + "img/221-Veka Spectral 9010-Blanc Pur.png";